import client from '@/client/apiClient';
import PlayerScore from '@/models/PlayerScore/playerScore';
import Game from '@/models/Game/game';

export default class PlayerScoreService {
  static getClubGamePlayersScore(id) {
    return client
      .get(`/club-games/${id}/player-score`)
      .then((response) => PlayerScore.createCollectionFromObject(response.data));
  }
  static getNationalTeamGamePlayersScore(id) {
    return client
      .get(`/national-team-games/${id}/player-score`)
      .then((response) => PlayerScore.createCollectionFromObject(response.data));
  }
  static updatePlayerScoreByClubGame(id) {
    return client
      .put(`/club-games/${id}/player-score`)
      .then((response) => Game.createFromObject(response.data));
  }
  static updatePlayerScoreByNationalTeamGame(id) {
    return client
      .put(`/national-team-games/${id}/player-score`)
      .then((response) => Game.createFromObject(response.data, true));
  }
};


